import { Container as MuiContainer } from '@mui/material';
import type { ContainerProps as MuiContainerProps } from '@mui/material';

export type ContainerProps = MuiContainerProps;

/** Root container is used to center content and takes full width until max 1140px (is set in the theme). Based on MUI Container: https://mui.com/material-ui/react-container/ */
export const Container = (props: ContainerProps) => <MuiContainer {...props} />;
